exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".appitem-component{list-style-position:inside;border:1px solid gray;margin:3px;padding:3px}.appitem-component img{width:55px;height:55px;float:left;margin:3px}.appitem-component a{text-decoration:none;color:#cc7108;font-weight:700;padding-left:20px;padding-right:20px;border:1px solid #cc7108}.appitem-component a:hover{color:#fff;background-color:#ad5f05;border:1px solid #cc7108}.appHeader{color:#cc7108;font-weight:700;cursor:pointer;height:50px;padding-top:9px}.appHeader:hover{background:#a9a9a9;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/AppItem.css
// module id = 134
// module chunks = 0